













import { defineComponent } from "@vue/composition-api";

import BaseTab from "@/components/BaseTab.vue";

export default defineComponent({
  name: "DocumentTabs",
  components: { BaseTab },
  props: {
    value: { type: String }
  },
  setup() {
    const types = [
      ["1", "Conditions & Symptoms"],
      ["7", "Procedures"],
      ["35", "Diag. Procedures"],
      ["4", "Labs & Vitals"],
      ["6", "Medications"],
      ["28", "Devices"]
    ];

    return { types };
  }
});
